import {Box, Typography} from "@mui/material"
import {styled} from "@mui/material/styles"

import {paletteColors} from "@indebted/theme"
import {ChevronForwardIcon} from "@indebted/assets"

function PaymentOption({
	Type,
	Title,
	Description,
	Disclaimer,
	onClick,
}: {
	Type: string
	Title: string
	Description: string
	Disclaimer?: string
	onClick: () => void
}) {
	return (
		<OptionBox onClick={onClick} data-testid={`payment-option-${Type}`}>
			<TextGroup>
				<Typography variant="body1" color="secondary" sx={{fontSize: "0.75rem"}}>
					{Description}
				</Typography>
				<Typography
					variant="h6"
					color="secondary"
					fontWeight={800}
					sx={{fontSize: "1.125rem", lineHeight: "1.5rem"}}
				>
					{Title}
				</Typography>
				{Disclaimer !== undefined && Disclaimer !== null && Disclaimer !== "" ? (
					<Typography variant="body2" color="text.secondary">
						{Disclaimer}
					</Typography>
				) : null}
			</TextGroup>
			<ChevronForwardIcon />
		</OptionBox>
	)
}

const OptionBox = styled(Box)(({theme}) => ({
	display: "flex",
	width: "100%",
	justifyContent: "space-between",
	alignItems: "center",
	backgroundColor: paletteColors.white,
	boxShadow: "0 4px 14px 2px rgba(54, 59, 100, 0.10)",
	borderRadius: 8,
	padding: "1rem",
	cursor: "pointer",
	"&:hover": {
		backgroundColor: theme.palette.background.default,
	},
}))

const TextGroup = styled(Box)`
	display: flex;
	flex-direction: column;
`

export {PaymentOption}
